
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Dashboard extends Vue {
    navigateTo(path: string) {
        if (this.$route.path !== path) {
            this.$router.push(path);
        }
    }
}
